import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow=true}) {

    let target = section.applicant === 1 ? `applicant1` : `applicant2`
    if (section.name.startsWith('assets')) {
        target = `${target}.assets`
    } else {
        target = `${target}.accounts`
    }
    let salariedAcExists = section.applicant === 1 ? section.mortgage.applicant1.accounts.find(it => !!it.salaried) : section.mortgage.applicant2.accounts.find(it => !!it.salaried)
    let jointQuestions = [
        {
            name: 'joint',
            label: 'Joint Acc',
            answer: {
                type: 'select',
                choices: [
                    {
                        value: true,
                        text: 'Yes'
                    }, {
                        value: false,
                        text: 'No'
                    }
                ]

            },
            target: `${target}[${section.index}].joint`
        }, {
            name: 'currency',
            label: 'Currency',
            answer: {
                type: 'text'
            },
            target: `${target}[${section.index}].currency`
        },
    ]
    if (!section.name.startsWith('assets')) {
        if (!salariedAcExists || salariedAcExists.id === section.index) {
            jointQuestions.push({
                name: 'salaried',
                label: 'Salaried',
                answer: {
                    type: 'select',
                    choices: [
                        {
                            value: true,
                            text: 'Yes'
                        }, {
                            value: false,
                            text: 'No'
                        }
                    ]
                },
                target: `${target}[${section.index}].salaried`
            })
        }
    }
    let questions = [
        [{
            name: 'institution',
            label: 'Bank Name',
            answer: {
                type: 'text',
            },
            target: `${target}[${section.index}].institution`
        }, {
            name: 'accountNumber',
            label: 'IBAN',
            answer: {
                type: 'text',
            },
            target: `${target}[${section.index}].accountNumber`
        }], jointQuestions, [

            {
                name: 'isClosed',
                label: 'Is Closed',
                answer: {
                    type: 'select',
                    choices: [
                        {
                            value: true,
                            text: 'Yes'
                        }, {
                            value: false,
                            text: 'No'
                        }
                    ]
                },
                target: `${target}[${section.index}].isClosed`
            }, {
                name: 'isNewAccount',
                label: 'Is New Account',
                answer: {
                    type: 'select',
                    choices: [
                        {
                            value: true,
                            text: 'Yes'
                        }, {
                            value: false,
                            text: 'No'
                        }
                    ]

                },
                target: `${target}[${section.index}].isNewAccount`
            }

        ]
    ]
    if (section.name.startsWith('current-accounts')) {
        let hasOverdraftRow = [
            {
                name: 'hasOverdraft',
                label: 'Has Overdraft',
                answer: {
                    type: 'select',
                    choices: [
                        {
                            value: true,
                            text: 'Yes'
                        }, {
                            value: false,
                            text: 'No'
                        }
                    ]
                },
                target: `${target}[${section.index}].hasOverdraft`
            }, {
                name: 'overdraftLimit',
                label: 'Overdraft Limit',
                answer: {
                    type: 'euro'
                },
                target: `${target}[${section.index}].overdraftLimit`,
            },
            {
                name: 'highestCreditUtilisation',
                label: 'Highest Credit Utilisation',
                answer: {
                    type: 'euro'
                },
                target: `${target}[${section.index}].highestCreditUtilisation`,
            },
        ]
        questions.push(hasOverdraftRow)

        let rentAc = section.applicant === 1 ? section.mortgage.applicant1.accounts.find(it => !!it.accommodationDD) : section.mortgage.applicant2.accounts.find(it => !!it.accommodationDD)
        if (!rentAc || rentAc.id === section.index) {
            let target2 = section.applicant === 1 ? `applicant1` : `applicant2`
            let lastTwo = [
                {
                    name: 'accommodationDD',
                    label: 'Accommodation DD',
                    answer: {
                        type: 'select',
                        choices: [
                            {
                                value: true,
                                text: 'Yes'
                            }, {
                                value: false,
                                text: 'No'
                            }
                        ]
                    },
                    target: `${target}[${section.index}].accommodationDD`
                }, {
                    name: 'monthlyAccommodationCosts',
                    label: 'Monthly Accommodation Costs',
                    answer: {
                        type: 'euro'
                    },
                    target: `${target2}.financial.monthlyAccommodationCosts`,
                }
            ]
            questions.push(lastTwo)
        }
    }

    // questions.push([
    //     {
    //         name: 'updateAtPreApproval',
    //         label: 'Preapproval Upd Fm',
    //         answer: {
    //             type: 'date',
    //         },
    //         target: `${target}[${section.index}].updateAtPreApproval`
    //     },
    //     {
    //         name: 'updateAtApproval',
    //         label: 'Approval Upd Fm',
    //         answer: {
    //             type: 'date',
    //         },
    //         target: `${target}[${section.index}].updateAtApproval`
    //     },
    //
    // ])
    return (
        <MortgageForm inExtWindow={inExtWindow} questions={questions}/>
    );
}

export default ApplicationForm;